import type { ReactNode } from 'react';

export type CartLineItemProps = {
  className?: string;
  children: ReactNode;
};

export const CartLineItem = ({ className, children }: CartLineItemProps) => {
  return <div className={className}>{children}</div>;
};
